(() => {
  const key = Symbol.for('walcom.editorial');
  if (window[key]) return;
  window[key] = true;
  const instances = new WeakMap();
  const mediaQuery = matchMedia('(max-width: 767px)');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function mediaCommand(root, play) {
    root.querySelectorAll('video, iframe').forEach(media => {
      const visible = media.getClientRects().length && getComputedStyle(media).visibility !== 'hidden';
      const active = play && visible;
      if (media.tagName === 'VIDEO') {
        if (active) media.play().catch(() => {}); else media.pause();
      } else {
        let origin;
        try { origin = new URL(media.src).origin; } catch { return; }
        if (origin === 'https://www.youtube.com') media.contentWindow?.postMessage(JSON.stringify({event: 'command', func: active ? 'playVideo' : 'pauseVideo', args: []}), origin);
        if (origin === 'https://player.vimeo.com') media.contentWindow?.postMessage(JSON.stringify({method: active ? 'play' : 'pause'}), origin);
      }
    });
  }
  function init(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const cleanup = [];
    instances.set(root, () => { abort.abort(); cleanup.forEach(fn => fn()); instances.delete(root); });
    root.querySelectorAll('[id="rich-text__lessMore"]').forEach(button => {
      const bottom = button.closest('.rich-text__content')?.querySelector('.rich-text__bottom');
      if (!bottom) return;
      let expanded = false;
      bottom.style.display = 'none';
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        expanded = !expanded;
        bottom.style.display = expanded ? 'block' : 'none';
        button.textContent = (expanded ? button.dataset.less : button.dataset.more)?.trim() || '';
        button.setAttribute('aria-expanded', String(expanded));
      }, {signal});
    });
    root.querySelectorAll('walcom-deferred-media').forEach(wrapper => {
      const poster = wrapper.querySelector('[id^="Deferred-Poster-"]');
      const load = () => {
        const template = wrapper.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          fragment.querySelectorAll('video,iframe').forEach(media => {
            const mobile = matchMedia('(max-width: 550px)').matches;
            if ((mobile && media.classList.contains('slide-pc')) || (!mobile && media.classList.contains('slide-mb'))) media.remove();
          });
          template.replaceWith(fragment);
        }
        wrapper.setAttribute('loaded', 'true');
        if (poster) poster.hidden = true;
        mediaCommand(wrapper, true);
      };
      poster?.addEventListener('click', load, {signal});
      if (!wrapper.querySelector('template')) {
        wrapper.setAttribute('loaded', 'true');
        const observer = new IntersectionObserver(entries => entries.forEach(entry => mediaCommand(wrapper, entry.isIntersecting)), {threshold: 0.15});
        observer.observe(wrapper); cleanup.push(() => observer.disconnect());
      }
    });
    root.querySelectorAll('[data-video-link] .video-button').forEach(button => {
      button.addEventListener('click', () => {
        const id = button.dataset.src;
        if (!id) return;
        const dialog = document.createElement('dialog');
        dialog.className = 'walcom-video-dialog';
        const close = document.createElement('button');
        close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close');
        const iframe = document.createElement('iframe');
        iframe.src = button.dataset.type === 'vimeo' ? `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1` : `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1`;
        iframe.title = button.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; encrypted-media; fullscreen'; iframe.allowFullscreen = true;
        dialog.append(close, iframe); root.append(dialog);
        close.addEventListener('click', () => dialog.close(), {signal});
        dialog.addEventListener('close', () => dialog.remove(), {once: true});
        dialog.showModal();
      }, {signal});
    });
    root.querySelectorAll('[data-scroll-down]').forEach(button => button.addEventListener('click', () => root.nextElementSibling?.scrollIntoView({behavior: reduceMotion.matches ? 'instant' : 'smooth'}), {signal}));
    const sliderSelectors = '[data-init-slideshow], [data-image-banner-slide], [data-smallimg-slide], [data-spotlight-slider], banner-slider-component .slider--tablet';
    root.querySelectorAll(sliderSelectors).forEach(track => {
      if (track.dataset.walcomSlider) return;
      track.dataset.walcomSlider = 'true';
      const items = Array.from(track.children).filter(el => el.matches('.item,.halo-item,.img-box'));
      if (items.length < 2) return;
      const mobileOnly = track.matches('.slider--tablet') && !track.hasAttribute('data-spotlight-slider');
      const single = track.matches('[data-init-slideshow],[data-image-banner-slide],[data-smallimg-slide]');
      const fade = single && !track.hasAttribute('data-smallimg-slide') && !['false', 'slide'].includes(track.dataset.fade);
      let index = 0, timer, pointerX;
      const host = track.closest('banner-slider-component') || track.parentElement;
      const existingControls = track.closest('banner-slider-component')?.querySelector('.slider-buttons');
      const controls = document.createElement('div'); controls.className = 'walcom-slider-controls';
      const previous = document.createElement('button'), next = document.createElement('button');
      previous.type = next.type = 'button'; previous.className = 'slick-prev slick-arrow'; next.className = 'slick-next slick-arrow';
      previous.textContent = '‹'; next.textContent = '›';
      previous.setAttribute('aria-label', 'Previous slide'); next.setAttribute('aria-label', 'Next slide');
      const dots = document.createElement('ul'); dots.className = 'slick-dots';
      const dotButtons = items.map((item, n) => {
        const li = document.createElement('li'), button = document.createElement('button'); button.type = 'button';
        button.textContent = String(n + 1); button.setAttribute('aria-label', `Slide ${n + 1}`);
        if (track.dataset.dotWithImage === 'true' && item.dataset.dotImg) {
          const image = document.createElement('img'); image.src = item.dataset.dotImg; image.alt = ''; button.replaceChildren(image);
        }
        button.addEventListener('click', () => go(n), {signal}); li.append(button); dots.append(li); return button;
      });
      controls.append(previous, next, dots); host.append(controls);
      function render() {
        const active = !mobileOnly || mediaQuery.matches;
        items.forEach(item => item.classList.add('walcom-slider-item'));
        const count = single ? 1 : Number(mediaQuery.matches ? track.dataset.rowsMb || 1 : track.dataset.rows || 1);
        track.classList.toggle('walcom-slider-active', active);
        track.classList.toggle('walcom-slider-fade', active && fade);
        track.style.setProperty('--walcom-slides-visible', String(count));
        track.style.setProperty('--walcom-slide-duration', `${track.hasAttribute('data-image-banner-slide') ? 1000 : 500}ms`);
        controls.hidden = !active;
        if (existingControls) existingControls.hidden = active;
        items.forEach((item, n) => {
          item.classList.toggle('slick-current', n === index);
          if (active && fade) {
            item.setAttribute('aria-hidden', String(n !== index)); item.inert = n !== index;
            mediaCommand(item, n === index);
          } else { item.removeAttribute('aria-hidden'); item.inert = false; }
          dotButtons[n].parentElement.classList.toggle('slick-active', n === index);
          dotButtons[n].setAttribute('aria-current', String(n === index));
        });
        const mobile = mediaQuery.matches;
        const arrows = mobile && track.dataset.arrowsMb !== undefined ? track.dataset.arrowsMb === 'true' : track.dataset.arrows !== undefined ? track.dataset.arrows === 'true' : Boolean(existingControls?.querySelector('.slider-action'));
        previous.hidden = next.hidden = !arrows || (track.hasAttribute('data-image-banner-slide') && innerWidth < 1500);
        const showDots = mobile && track.dataset.dotsMb !== undefined ? track.dataset.dotsMb !== 'false' : track.dataset.dots !== undefined ? track.dataset.dots !== 'false' : track.hasAttribute('data-smallimg-slide') || Boolean(existingControls?.querySelector('.slider-dots'));
        dots.hidden = !showDots;
      }
      function go(n) {
        index = (n + items.length) % items.length;
        render();
        if (!fade && (!mobileOnly || mediaQuery.matches)) track.scrollTo({left: items[index].offsetLeft - items[0].offsetLeft, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
      }
      previous.addEventListener('click', () => go(index - 1), {signal}); next.addEventListener('click', () => go(index + 1), {signal});
      host.querySelectorAll('.slider-button,[name="dots"]').forEach(button => button.addEventListener('click', () => go(button.name === 'dots' ? Number(button.dataset.index) : index + (button.name === 'previous' ? -1 : 1)), {signal}));
      track.addEventListener('pointerdown', event => { pointerX = event.clientX; }, {signal});
      track.addEventListener('pointerup', event => {
        if (fade && pointerX !== undefined && Math.abs(event.clientX - pointerX) > 40) go(index + (event.clientX < pointerX ? 1 : -1));
        pointerX = undefined;
      }, {signal});
      track.addEventListener('scroll', () => {
        if (fade) return;
        const left = track.getBoundingClientRect().left;
        index = items.reduce((best, item, n) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(items[best].getBoundingClientRect().left - left) ? n : best, 0);
        dotButtons.forEach((button, n) => {button.parentElement.classList.toggle('slick-active', n === index); button.setAttribute('aria-current', String(n === index));});
      }, {signal, passive: true});
      if (track.dataset.autoplay === 'true' && !reduceMotion.matches) {
        timer = setInterval(() => { if (root.isConnected && !host.matches(':hover,:focus-within') && !document.hidden) go(index + 1); }, Math.max(1000, Number(track.dataset.autoplaySpeed) || 5000));
        cleanup.push(() => clearInterval(timer));
      }
      window.addEventListener('resize', render, {signal});
      cleanup.push(() => controls.remove()); render();
    });
    root.querySelectorAll('.scroll-trigger').forEach(element => element.classList.add('walcom-editorial-visible'));
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-walcom-editorial]')) init(scope);
    scope.querySelectorAll('[data-walcom-editorial]').forEach(init);
  }
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-walcom-editorial]').forEach(root => instances.get(root)?.()));
})();
